// menuConfig.js - Centralized menu configuration  
// HDO-8090 - created a centralized menu configuration file to manage the menu items for better maintainability as per roles.
const MENU_CONFIG = {
    commonItems: [
        {
            id: 'home',
            label: 'Home',
            path: '/incident/dashboard',
            icon: 'pi pi-fw pi-home',
        },
        {
            id: 'platformHealth',
            label: 'Platform Health',
            path: '/leader/dashboard',
            icon: 'pi pi-heart',
        },
    ],

    monitor: {
        label: 'Monitor',
        icon: 'pi pi-fw pi-desktop',
        items: [
            { id: 'inboundInactivity', label: 'Inbound Inactivity', path: '/monitor/inboundmetric', icon: 'pi pi-fw pi-angle-double-right' },
            { id: 'queues', label: 'Queues', path: '/monitor/queues', icon: 'pi pi-fw pi-arrow-right-arrow-left' },
            { id: 'scheduledTask', label: 'Scheduled Task', path: '/monitor/taskschedule', icon: 'pi pi-fw pi-stopwatch' },
            { id: 'databaseSize', label: 'Database Size', path: '/monitor/databasesize', icon: 'pi pi-database' },
            { id: 'mirrorStatus', label: 'Mirror Status', path: '/monitor/mirrors', icon: 'pi pi-fw pi-clone' },
            { id: 'galileo', label: 'Galileo', path: '/galileo', icon: 'pi pi-chart-bar' },
        ]
    },

    otherItems: [
        { id: 'productionItems', label: 'Production Items', path: '/monitor/production/items', icon: 'pi pi-fw pi-sliders-h' },
        { id: 'iacl', label: 'IACL', path: '/iacl', icon: 'pi pi-fw pi-bolt' },
        { id: 'ipPortList', label: 'IP Port List', path: '/production/ipport', icon: 'pi pi-map-marker' },
    ],

    reports: {
        label: 'Reports',
        icon: 'pi pi-fw pi-paperclip',
        items: [
            { id: 'interfaceCount', label: 'Interface Count', path: '/report/interfacecount', icon: 'pi pi-fw pi-list' },
            { id: 'interfaceTracker', label: 'Interface Tracker', path: '/report/interfacetracker', icon: 'pi pi-fw pi-list' },
        ]
    },

    admin: {
        commonItems: [
            { id: 'doNotMonitor', label: 'Do-not-monitor', path: '/notification/blackout/rules', icon: 'pi pi-eye-slash' },
            { id: 'restoreConnection', label: 'Restore Connection', path: '/restore/connection', icon: 'pi pi-fw pi-replay' },
            {
                id: 'iaclConfigs', label: 'IACL Configs', icon: 'pi pi-fw pi-cog', items: [
                    { id: 'applications', label: 'Applications', path: '/application', icon: 'pi pi-fw pi-box' },
                    { id: 'caGroupNames', label: 'CA Group Names', path: '/cagroupname', icon: 'pi pi-fw pi-users' },
                    { id: 'connectionTypes', label: 'Connection Types', path: '/connectiontypes', icon: 'pi pi-fw pi-wifi' },
                    { id: 'messageTypes', label: 'Message Types', path: '/messagetype', icon: 'pi pi-fw pi-list' },
                    { id: 'messageContent', label: 'Message Content', path: '/messagecontent', icon: 'pi pi-fw pi-book' },
                    { id: 'siteNames', label: 'Site Names', path: '/sitenames', icon: 'pi pi-fw pi-building' },
                ]
            },
            { id: 'actionGroup', label: 'Action Group', path: '/admin/alert/actiongroup', icon: 'pi pi-fw pi-users' },
            { id: 'rabbitMqUsers', label: 'Rabbit Mq Users', path: '/rabbitmq/authusers', icon: 'pi pi-fw pi-user' },
        ],
        adminOnlyItems: [
            {
                id: 'alertRule',
                label: 'Alert Rule',
                icon: 'pi pi-fw pi-book',
                items: [
                    { id: 'customAlert', label: 'Custom Alert', path: '/admin/custom/hie/alert/rules', icon: 'pi pi-fw pi-send' },
                    { id: 'azureAlert', label: 'Azure Alert', path: '/admin/custom/azure/alert/rules', icon: 'pi pi-fw pi-cloud' },
                    { id: 'thresholdRule', label: 'Threshold Rule', path: '/admin/threshold/rules', icon: 'pi pi-fw pi-list' },
                    { id: 'alertProcessing', label: 'Alert Processing', path: '/admin/alert/processing/rules', icon: 'pi pi-fw pi-cog' },
                ]
            }
        ]
    }
};

export default MENU_CONFIG;  